import Cookies from 'js-cookie';

const SET_LANGUAGE = 'SET_LANGUAGE';

const languageMiddleware = (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === SET_LANGUAGE) {
        Cookies.set('locale', action.payload, { expires: 365 });
    }

    return result;
};

export default languageMiddleware;
